import angular from "angular";
import { directiveFactory } from "../angular-core";

export class IndeterminateCheckboxDirective implements ng.IDirective {
    static componentName: string = "indeterminateCheckbox";

    scope = true;
    require = "?ngModel";

    link = (scope: ng.IScope, element: JQLite, attrs: ng.IAttributes, modelCtrl: $TSFixMe) => {
        var childList = attrs.childList;
        var property = attrs.property;
        var filter = attrs.filter;

        // Bind the onChange event to update children
        element.bind("change", function () {
            scope.$apply(function () {
                var isChecked = element.prop("checked");

                // Set each child's selected property to the checkbox's checked property

                angular.forEach(scope.$eval(childList), function (child: $TSFixMe) {
                    if ((filter && scope.$eval(filter)(child)) || !filter) {
                        child[property] = isChecked;
                    }
                });
            });
        });

        // Watch the children for changes
        scope.$watch(
            childList,
            function (newValue: $TSFixMe) {
                var hasChecked = false;
                var hasUnchecked = false;
                // Loop through the children

                angular.forEach(newValue, function (child: $TSFixMe) {
                    if ((filter && scope.$eval(filter)(child)) || !filter) {
                        if (child[property]) {
                            hasChecked = true;
                        } else {
                            hasUnchecked = true;
                        }
                    }
                });

                // Determine which state to put the checkbox in
                if (hasChecked && hasUnchecked) {
                    element.prop("checked", false);
                    element.prop("indeterminate", true);
                    if (modelCtrl) {
                        modelCtrl.$setViewValue(false);
                    }
                } else {
                    element.prop("checked", hasChecked);
                    element.prop("indeterminate", false);
                    if (modelCtrl) {
                        modelCtrl.$setViewValue(hasChecked);
                    }
                }
            },
            true
        );
    };
}

angular
    .module("indeterminateCheckbox")
    .directive(IndeterminateCheckboxDirective.componentName, directiveFactory(IndeterminateCheckboxDirective));
